module.exports = __webpack_public_path__ + "img/yidong.865304d9.png";